import React from "react";
import { AlertTriangle, X } from "lucide-react";

export default function CancelWarningModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Are you sure?",
  message = "Cancelling this booking will submit a request for review. Would you like to proceed with the cancellation?",
}) {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-[2px] z-[950] transition-opacity"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 z-[951] flex items-center justify-center p-4">
        <div className="bg-white rounded-[24px] shadow-2xl w-full max-w-[420px] p-6 sm:p-7 text-center relative animate-fade-in flex flex-col items-center">
          {/* Close button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 transition-colors"
            title="Close"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Orange Circle with Alert Triangle and Exclamation Mark */}
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-[#FF4D12] text-white flex items-center justify-center mb-5 shadow-lg shadow-[#FF4D12]/20">
            <AlertTriangle className="w-9 h-9 sm:w-11 sm:h-11 stroke-[2.5]" />
          </div>

          {/* Title */}
          <h3 className="text-xl sm:text-2xl font-extrabold text-gray-950 mb-2 tracking-tight">
            {title}
          </h3>

          {/* Description */}
          <p className="text-xs sm:text-sm text-gray-500 mb-6 leading-relaxed max-w-[320px]">
            {message}
          </p>

          {/* Action Buttons */}
          <div className="w-full flex gap-3">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-3 border border-gray-200 hover:bg-gray-50 text-gray-700 font-bold rounded-xl text-xs sm:text-sm transition"
            >
              No, Keep Booking
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="flex-1 py-3 bg-[#FF4D12] hover:bg-[#e64415] text-white font-bold rounded-xl text-xs sm:text-sm transition shadow-sm active:scale-[0.99]"
            >
              Yes, Continue
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
